import { OrdersState } from 'state/orders';

export const isOrderStateEmpty = (orders: OrdersState): boolean => {
    if (!orders) {
        return true;
    }

    return Object.values(orders).every(({ cart }) => cart.length === 0);
};
